import React from 'react';
import { NavigationBar } from 'arag-ui-lib';
import styles from './claimTabs.module.scss';

const CLAIM_TABS = navItems => {
    return Object.entries(navItems).map(([key, tab]) => ({
        key: tab.key,
        label: tab.label,
        navItemTestId: `navItem_${tab.key}`,
    }));
};

const ClaimTabs = props => {
    const { activeTab, handleTabClick, navItems } = props;

    return (
        <div className={'row'}>
            <div className={`col-sm-12 ${styles['claim-tabs-wrapper']}`}>
                <NavigationBar
                    onNavItemSelect={handleTabClick}
                    activeItemKey={activeTab}
                    navItems={navItems ? CLAIM_TABS(navItems) : []}
                />
            </div>
        </div>
    );
};

export default ClaimTabs;
